import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const ShiftCycleTemplateWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "shift-cycle-template-wrapper",
})``;
